import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    data: [],
};

const luckySpinGiftAssignReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.value,
    }),
    [type.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
    [type.UPDATE_STATUS]: (state, action) => ({
        ...state,
        updateStatus: action.value,
    }),
    [type.DELETE]: (state, action) => ({
        ...state,
        delete: action.value,
    }),
    [type.GET_MEMBER]: (state, action) => ({
        ...state,
        member: action.value,
    }),
});

export default luckySpinGiftAssignReducer;